import { useEditorHighlight } from "./react.tsx";

/** Monaco token markup with a separate match overlay. */
export function HighlightedPreview({ file, preview }: {
  readonly file: string;
  readonly preview: { readonly before: string; readonly match: string; readonly after: string };
}) {
  const text = preview.before + preview.match + preview.after;
  const html = useEditorHighlight(file, text);

  return (
    <span className="relative inline-block overflow-hidden whitespace-pre font-mono text-[11px] leading-4">
      <span
        aria-hidden
        className="absolute inset-y-0 rounded-[2px] bg-status-warning/30"
        style={{
          left: `${preview.before.length}ch`,
          width: `${preview.match.length}ch`
        }}
      />
      {html ? (
        <span
          className="relative"
          // biome-ignore lint: markup comes from monaco's tokenizer
          dangerouslySetInnerHTML={{ __html: html }}
        />
      ) : (
        <span className="relative text-kumo-subtle">{text}</span>
      )}
    </span>
  );
}
